var $ = global.jQuery = global.$;
var mapConfig = require('config').maps;

var _Map = require('./_Map');

/**
 * Locations map
 * @class
 * @extends _Map
 */
var LocMap = _Map.extend(
  /** @lends LocMap.prototype */
  {
  /**
   * Runs when then map is loaded using the google map loader in the _Map base.
   * @param {object} google The google instance that is passed through by the google map loader in the _Map init() method
   */
  onMapLoaded: function(google) {
    var self = this;

    if (Modernizr.touchevents) {
      this.map.setOptions({
        draggable: false
      });
    }

    this.defaultIcon = {
      url: '/assets/images/map-pin.svg',
      scaledSize: new google.maps.Size(32, 50)
    };

    this.cluster.setStyles([{
      anchorIcon: [50, 0],
      anchorText: [-8, 0],
      fontFamily: 'Arial',
      fontWeight: 'bold',
      textColor: '#b4985a',
      height: 50,
      textSize: 15,
      url: '/assets/images/map-pin.svg',
      width: 32
    }]);
  }
});

module.exports = LocMap;



/*****************
 ** WEBPACK FOOTER
 ** ./source/scripts/widgets/LocMap.js
 ** module id = 158
 ** module chunks = 0 1
 **/